(function ($) {
  'use strict';

  if (!$) {
    console.error('PWR Reviews: jQuery is not loaded.');
    return;
  }

  console.log('PWR Reviews: jQuery loaded');

  /* ============================================================
     ACTIVATE REVIEW
     ============================================================ */
  function activateReview(id, animate) {

    if (!id) {
      console.warn('PWR Reviews: Missing review ID');
      return;
    }

    console.log('PWR Reviews: activating', id);

    /*
     * Find the closest Reviews section.
     * This prevents multiple review sections from affecting
     * each other.
     */
    var $card = $('[data-pwr-review-card="' + id + '"]').first();
    var $section = $card.closest('.pwr-reviews');

    if (!$section.length) {
      console.warn('PWR Reviews: Section not found for', id);
      return;
    }

    /* ------------------------------------------------------------
       REVIEW CARDS
       ------------------------------------------------------------ */

    $section
      .find('[data-pwr-review-card]')
      .removeClass('is-active')
      .attr('aria-pressed', 'false')
      .attr('tabindex', '-1');

    $card
      .addClass('is-active')
      .attr('aria-pressed', 'true')
      .attr('tabindex', '0');


    /* ------------------------------------------------------------
       REVIEW STORIES
       ------------------------------------------------------------ */

    var $stories = $section.find('[data-pwr-review-story]');
    var $activeStory = $section.find(
      '[data-pwr-review-story="' + id + '"]'
    );

    if (!$activeStory.length) {
      console.warn('PWR Reviews: Story not found for', id);
      return;
    }

    /*
     * Hide all stories first.
     */
    $stories
      .removeClass('is-active')
      .attr('hidden', true)
      .stop(true, true)
      .hide();


    /*
     * Show selected story.
     */
    $activeStory
      .removeAttr('hidden')
      .addClass('is-active');

    if (animate === false) {

      $activeStory
        .css('display', 'grid');

    } else {

      $activeStory
        .css('display', 'grid')
        .hide()
        .fadeIn(250);

    }


    /* ------------------------------------------------------------
       ACCESSIBILITY
       ------------------------------------------------------------ */

    $section
      .find('[data-pwr-review-card]')
      .each(function () {

        var $this = $(this);

        $this.attr(
          'aria-selected',
          $this.hasClass('is-active') ? 'true' : 'false'
        );

      });

  }


  /* ============================================================
     REVIEW CARD CLICK
     ============================================================ */

  $(document)
    .off('click.pwrReviews', '[data-pwr-review-card]')
    .on(
      'click.pwrReviews',
      '[data-pwr-review-card]',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        var id = $(this).attr('data-pwr-review-card');

        console.log('PWR Reviews: CARD CLICK', id);

        activateReview(id, true);
      }
    );


  /* ============================================================
     KEYBOARD SUPPORT
     ============================================================ */

  $(document)
    .off('keydown.pwrReviews', '[data-pwr-review-card]')
    .on(
      'keydown.pwrReviews',
      '[data-pwr-review-card]',
      function (event) {

        var $section = $(this).closest('.pwr-reviews');
        var $cards = $section.find('[data-pwr-review-card]');
        var currentIndex = $cards.index(this);

        var nextIndex = currentIndex;

        switch (event.key) {

          case 'ArrowRight':
          case 'ArrowDown':

            nextIndex =
              currentIndex >= $cards.length - 1
                ? 0
                : currentIndex + 1;

            break;

          case 'ArrowLeft':
          case 'ArrowUp':

            nextIndex =
              currentIndex <= 0
                ? $cards.length - 1
                : currentIndex - 1;

            break;

          case 'Home':

            nextIndex = 0;

            break;

          case 'End':

            nextIndex = $cards.length - 1;

            break;

          case 'Enter':
          case ' ':

            event.preventDefault();

            activateReview(
              $(this).attr('data-pwr-review-card'),
              true
            );

            return;

          default:
            return;
        }

        event.preventDefault();

        var $next = $cards.eq(nextIndex);

        $next.focus();

        activateReview(
          $next.attr('data-pwr-review-card'),
          true
        );
      }
    );


  /* ============================================================
     INITIAL ACTIVE REVIEW
     ============================================================ */

  function initializeReviews(scope) {

    var $scope = scope ? $(scope) : $(document);

    $scope.find('.pwr-reviews').each(function () {

      var $section = $(this);

      var $activeCard = $section
        .find('[data-pwr-review-card].is-active')
        .first();

      if (!$activeCard.length) {

        $activeCard = $section
          .find('[data-pwr-review-card]')
          .first();

      }

      if (!$activeCard.length) {
        return;
      }

      var id = $activeCard.attr('data-pwr-review-card');

      /*
       * Initial state without animation.
       */
      activateReview(id, false);

    });

  }


  /* ============================================================
     DOM READY
     ============================================================ */

  $(function () {

    console.log('PWR Reviews: DOM ready');

    initializeReviews(document);

  });


  /* ============================================================
     SHOPIFY THEME EDITOR
     ============================================================ */

  $(document)
    .off('shopify:section:load.pwrReviews')
    .on(
      'shopify:section:load.pwrReviews',
      function (event) {

        console.log(
          'PWR Reviews: Shopify section loaded',
          event.target
        );

        initializeReviews(event.target);

      }
    );


  /* ============================================================
     SHOPIFY BLOCK SELECT
     ============================================================ */

  $(document)
    .off('shopify:block:select.pwrReviews')
    .on(
      'shopify:block:select.pwrReviews',
      function (event) {

        var blockId = event.detail && event.detail.blockId;

        if (!blockId) {
          return;
        }

        var $block = $(
          '[data-block-id="' + blockId + '"]'
        );

        if (!$block.length) {
          return;
        }

        var id = $block.attr('data-pwr-review-card');

        if (id) {

          console.log(
            'PWR Reviews: Theme editor block selected',
            id
          );

          activateReview(id, false);

        }

      }
    );


})(window.jQuery);